import { useEffect, useRef } from 'react';
import useWindowScroll from 'hooks/useWindowScroll';

export default function useAnchor({ id, setTabSelected, scrollBaseTop }) {
  const elementRef = useRef(null);
  const { scrollY } = useWindowScroll();

  const elementHeight = elementRef.current?.offsetHeight;
  const elementTop = elementRef.current?.offsetTop;
  const elementBottom = elementTop + elementHeight;

  useEffect(() => {
    if (
      elementTop - scrollBaseTop <= scrollY &&
      scrollY <= elementBottom - scrollBaseTop
    ) {
      setTabSelected(id);
    }
  }, [elementTop, elementBottom, scrollBaseTop, scrollY, setTabSelected, id]);

  return { elementRef, topOfScroll: elementTop - scrollBaseTop };
}
